import axiosInstance from '../auth/axiosConfig';
import {
  UBICACION_REQUEST,
  UBICACION_SUCCESS,
  UBICACION_FAIL,
} from './types';
import { Dispatch } from 'redux';


export const ubicacionActions = (anioSeleccionado: number, establ_corr: number) => async (dispatch: Dispatch): Promise<boolean> => {

  dispatch({ type: UBICACION_REQUEST });

  try {
    const res = await axiosInstance.get(`${import.meta.env.VITE_CSRF_API_URL}/ubicacionActions?anioSeleccionado=${anioSeleccionado}&establ_corr=${establ_corr}`);

    if (res.status === 200) {
      if (res.data) {
        dispatch({
          type: UBICACION_SUCCESS,
          payload: res.data
        });
        return true;
      }

    } else {
      dispatch({ type: UBICACION_FAIL });
    }
    return false;
  } catch (err: any) {
    dispatch({
      type: UBICACION_FAIL,
      error: "Error en la solicitud:", err,
    });
    return false;
  }
};
